export default __webpack_public_path__ + "static/media/ScenicAndCulturalTrips10.21531ba7.png";